// Browser messages for a dynamic import that failed to load (Safari, Chrome, Firefox).
const MODULE_LOAD_FAILURE = /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

// Guards against a reload loop when a file is genuinely missing.
const RELOADED_AT_KEY = 'kerika-module-reload-at';
const RELOAD_MIN_INTERVAL = 5 * 60 * 1000;

/**
 * A lazy module fails to import when a page still running the previous release is served the new
 * release's files by the updated service worker. Part of the app (e.g. the header) then stays missing
 * until the app is restarted, so the page is reloaded once to load every file from the same release.
 * @param {Error} error the error thrown by the dynamic `import()`.
 * @returns {boolean} true when a reload is scheduled.
 */
export const recoverFromModuleLoadFailure = (error) => {
  if (!MODULE_LOAD_FAILURE.test(String(error && error.message || error))) {
    return false;
  }

  if (!navigator.onLine || Date.now() - lastReloadedAt() <= RELOAD_MIN_INTERVAL) {
    return false;
  }

  reloadWhenVisible();
  return true;
};

const lastReloadedAt = () => {
  try {
    return Number(window.sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
  } catch (error) {
    return 0;
  }
};

const reload = () => {
  try {
    window.sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
  } catch (error) {
    // Without sessionStorage the reload still goes ahead.
  }
  window.location.reload();
};

const reloadWhenVisible = () => {
  if (document.visibilityState === 'visible') {
    reload();
    return;
  }

  const reloadOnVisible = () => {
    if (document.visibilityState !== 'visible') {
      return;
    }
    document.removeEventListener('visibilitychange', reloadOnVisible);
    reload();
  };
  document.addEventListener('visibilitychange', reloadOnVisible);
};
